<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { Writable } from "svelte/store";
  import type { Field } from "svelte-forms2/types";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  type FormField = Omit<Writable<Field<string>>, "set"> & {
    validate: () => Promise<Field<string>>;
    reset: () => void;
    clear: () => void;
    set(this: void, value: string | Field<string>): void;
  };

  export let classes: string = "fizz-full-width fizz-flow-4 fizz-stack-16 fizz-inline-block";
  export let name: string = "password";
  export let id: string = name;
  export let field: FormField;
  export let label: string = "Password";
  export let labelClasses: string = "fizz-stack-8";
  export let placeholder = "";
  export let showPasswordToggle = false;
  export let testid: string = id;

  const dispatch = createEventDispatcher();

  const onBlur = (e: FocusEvent): void => {
    dispatch("blur", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onChange = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onFocus = (e: FocusEvent): void => {
    dispatch("click", { target: e.currentTarget, field, fieldValue: $field });
  };

  const typeAction = node => {
    node.type = showPassword ? "text" : "password";
  };

  $: component = null;

  $: showPassword = false;

</script>

<label class={classes} style="position: relative">
  <p class="fizz-label {labelClasses} "><strong>{label}</strong></p>
  <div class="fizz-relative fizz-inline-block fizz-full-width">
    <div class="fizz-input-text fizz-input-with-button" class:fizz-input-error={!$field.valid}>
      <input
        bind:this={component}
        {name}
        {id}
        {placeholder}
        data-testId={testid}
        use:typeAction
        bind:value={$field.value}
        on:blur={onBlur}
        on:change={onChange}
        on:focus={onFocus}
      />
    </div>
    {#if showPasswordToggle}
      <button class="fizz-icon-button-small" type="button" on:click|preventDefault>
        <Icon
          type={showPassword ? "Eye" : "EyeClosed"}
          width="18"
          height="18"
          onPress={() => {
            showPassword = !showPassword;
            typeAction(component);
          }}
        />
      </button>
    {/if}
  </div>

  <slot />
</label>
